window["addFileuploadError"] = function (msg) {
    var imgContainer = $('#img-container');
    var li = $('<li/>').appendTo(imgContainer);
    var title = $('<div/>').addClass('uploadFail').text(msg + ' ').appendTo(li);
    var cancelButton = $('<a/>').attr({
        href: '#cancel',
        'class': 'cancel',
        title: 'Remove'
    }).text('X').appendTo(title);

    cancelButton.click(function () {
        li.remove();
        return false;
    });

}

$(function () {
    if ($('.pageAlbums').length == 0) {
        return;
    }

    $('.album-edit__cover-radio').change(function () {
        $(this).closest('form').submit();
    });

    $(".select_mt").change(function () {
        const pid = $(this).data("photo-id");
        const tgt_id = $(this);
        const caid = $("#cur_aid");
        const stat = $("#" + pid + "_mt_stat");

        stat.addClass("ajx_load").text(window.t('common.moving'));

        $.get("/app/albums", {
                todo: "move",
                photo_id: pid,
                aid: tgt_id.val(),
                cur_aid: caid.val()
            },
            function (data) {
                stat.removeClass("ajx_load");
                if (data === "FULL") {
                    stat.addClass("ajx_err");
                    stat.html("<b>" + window.t('common.error') + ":</b> " + window.t('common.album_full'));
                } else if (data == "0") {
                    stat.addClass("ajx_err");
                    stat.html("<b>" + window.t('common.error') + ":</b> " + window.t('common.server_error'));
                } else {
                    stat.parents(".albPhotoBox")
                        .addClass("closeable")
                        .html(data)
                        .children(".closer")
                        .click(function () {
                            $(this).parent(".closeable").hide();
                        });
                }
            });
    });

    $('#fupAddFile').addClass('clickable underlink_inline').click(function () {
        const slots = $('#file_slots'),
            new_total = Number(slots.val()) + 1,
            new_slot = new_total - 1;

        if (new_total > 10) {
            alert(window.t('common.photo_upload_limit'));
        } else {
            $('#fupFiles').append("<br /><label>File #" + new_total + ":</label>" +
                "<input type='file' name='slot" + new_slot + "' class='fileUpload'>");
            slots.val(new_total);
        }
    });

    if (window.location.hash.indexOf(('#coverThumbEdit')) !== -1) {
        $('#coverThumbEditLink').click();
    }

    var cropMatch = window.location.hash.match(/^#crop_(.+)$/);
    if (cropMatch) {
        var photoId = cropMatch[1];
        if (typeof window.showCrop === 'function') {
            window.showCrop(photoId);
        }
    }

});

// jCrop related
window["hideNewUpload"] = function () {
    $('#newupload').hide();
    $('#upload').show();
    return false;
}

// photo id with activated crop
window["active_crop"] = null;
// active jcrop instance (Jcrop on desktop, Cropper.js on touch)
window["jcrop_api"] = null;
window["_isTouchCrop"] = false;

window["_cropEscHandler"] = function (e) {
    if (e.key === 'Escape' && active_crop) {
        hide_crop(active_crop);
    }
};

window["_isTouchDevice"] = function () {
    return window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
};

window["showCrop"] = function (photoId) {
    if (active_crop) {
        hide_crop(active_crop);
    }
    $('#albPhotoEditBox_' + photoId).hide();
    var cropbox = $('#cropBox_' + photoId);
    var isFullscreenModal = cropbox.hasClass('fixed');

    if (isFullscreenModal) {
        cropbox.removeClass('hidden').css('display', 'flex');
    } else {
        cropbox.show();
    }

    document.addEventListener('keydown', _cropEscHandler);

    var im = $('#ct_' + photoId);
    var useTouch = _isTouchDevice() && window.Cropper;
    window["_isTouchCrop"] = useTouch;

    var initCropper = function () {
        if (useTouch) {
            var imgEl = im.get(0);
            // Set the container to a fixed square before initializing
            var container = imgEl.parentElement;
            var containerWidth = container.clientWidth;
            container.style.height = containerWidth + 'px';
            container.style.overflow = 'hidden';

            var minCropSide = Math.max(parseInt(cropbox.data('msx')) || 180, 180);

            window["jcrop_api"] = new window.Cropper(imgEl, {
                aspectRatio: 1,
                viewMode: 3,
                dragMode: 'move',
                cropBoxMovable: false,
                cropBoxResizable: false,
                toggleDragModeOnDblclick: false,
                autoCropArea: 1,
                guides: true,
                center: false,
                highlight: false,
                background: false,
                modal: false,
                zoom: function (e) {
                    var cropData = this.cropper.getData();
                    if (e.detail.ratio > e.detail.oldRatio && (cropData.width < minCropSide || cropData.height < minCropSide)) {
                        e.preventDefault();
                    }
                },
                ready: function () {
                    // Hide the crop box lines — the container edge IS the crop boundary
                    var cropBox = this.cropper.cropBox;
                    if (cropBox) {
                        cropBox.style.border = 'none';
                        cropBox.style.outline = 'none';
                    }
                    // Style the guides as subtle white lines (rule-of-thirds grid)
                    var guideLines = this.cropper.cropBox ? this.cropper.cropBox.querySelectorAll('.cropper-line') : [];
                    guideLines.forEach(function (line) { line.style.backgroundColor = 'rgba(255,255,255,0.3)'; });
                    var dashes = this.cropper.cropBox ? this.cropper.cropBox.querySelectorAll('.cropper-dashed') : [];
                    dashes.forEach(function (d) { d.style.borderColor = 'rgba(255,255,255,0.4)'; });
                    // Hide resize handles
                    var points = this.cropper.cropBox ? this.cropper.cropBox.querySelectorAll('.cropper-point') : [];
                    points.forEach(function (p) { p.style.display = 'none'; });

                    if (im.data('tx') >= 0 && im.data('ty') >= 0 && im.data('ts') > 0) {
                        this.cropper.setData({
                            x: Math.floor(im.data('tx')),
                            y: Math.floor(im.data('ty')),
                            width: Math.floor(im.data('ts')),
                            height: Math.floor(im.data('ts'))
                        });
                    }
                }
            });
        } else {
            var imgEl = im.get(0);
            var ow = imgEl.naturalWidth || parseInt(cropbox.data('ow')) || 0;
            var oh = imgEl.naturalHeight || parseInt(cropbox.data('oh')) || 0;
            var jcrop_params = {
                bgColor: 'black',
                bgOpacity: .4,
                aspectRatio: 1,
                boxWidth: 550,
                boxHeight: 550,
                keySupport: false,
                minSize: [cropbox.data('msx'), cropbox.data('msy')]
            };
            if (ow && oh) {
                jcrop_params.trueSize = [ow, oh];
            }
            var jcrop_callback = function () {
                var w = ow || im.width(),
                    h = oh || im.height(),
                    min_side = w > h ? h : w,
                    half_ms = Math.floor(min_side / 2),
                    cx = Math.floor(w / 2),
                    cy = Math.floor(h / 2),
                    x1 = cx - half_ms,
                    y1 = cy - half_ms,
                    x2 = cx + half_ms,
                    y2 = cy + half_ms;

                if (im.data('tx') >= 0 && im.data('ty') >= 0 && im.data('ts') > 0) {
                    x1 = Math.floor(im.data('tx'));
                    y1 = Math.floor(im.data('ty'));
                    x2 = x1 + Math.floor(im.data('ts'));
                    y2 = y1 + Math.floor(im.data('ts'));
                }
                window["jcrop_api"] = this;
                jcrop_api.setOptions({ setSelect: [x1, y1, x2, y2] });
                if (!isFullscreenModal) {
                    cropbox[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            };
            im.Jcrop(jcrop_params, jcrop_callback);
        }
        window["active_crop"] = photoId;
    };

    if (!im.attr('src')) {
        im.load(function () {
            var doInit = function () {
                im.removeClass('loading');
                initCropper();
            };
            if (!im.get(0).complete) {
                window.setTimeout(doInit, 250);
            } else {
                doInit();
            }
        })
            .error(function () {
                console.error('Error loading crop image');
            })
            .addClass('loading')
            .attr("src", im.data("src"));
    } else {
        initCropper();
    }
    return false;
}

window["hide_crop"] = function (photoId) {
    document.removeEventListener('keydown', _cropEscHandler);
    window["active_crop"] = null;
    if (jcrop_api && jcrop_api.destroy) {
        jcrop_api.destroy();
    }
    window["jcrop_api"] = null;
    window["_isTouchCrop"] = false;
    var cropbox = $('#cropBox_' + photoId);
    cropbox.addClass('hidden').css('display', '');
    $('#albPhotoEditBox_' + photoId).show();
    if (/^#crop_/.test(window.location.hash)) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    return false;
}

window["generateThumb"] = function (photoId) {
    var x, y, w, h;

    if (_isTouchCrop && jcrop_api && jcrop_api.getData) {
        // Cropper.js — getData returns coordinates in original image pixels
        var data = jcrop_api.getData(true);
        x = data.x;
        y = data.y;
        w = Math.floor(data.width);
        h = Math.floor(data.height);
    } else if (jcrop_api && jcrop_api.tellSelect) {
        // Jcrop — tellSelect returns unscaled coordinates
        var sel = jcrop_api.tellSelect();
        x = Math.floor(sel.x);
        y = Math.floor(sel.y);
        w = Math.floor(sel.w);
        h = Math.floor(sel.h);
    } else {
        return false;
    }

    if (!w) {
        alert(window.t('common.crop_select_region'));
        return false;
    }

    x = Math.max(0, x);
    y = Math.max(0, y);

    var postData = { csrf_token: $('meta[name="csrf_token"]').attr('content') };
    var params = {
        'todo': 'crop',
        'aid': $('#cur_aid').val(),
        'pid': photoId,
        'x': x,
        'y': y,
        'x2': x + w,
        'y2': y + h,
        'h': h,
        'w': w,
        'csrf_token': postData.csrf_token
    };
    hide_crop(photoId);
    // Hide photo edit details
    $('#albPhotoEditBox_' + photoId).hide();
    // Show "processing ..."
    $('#cropStatus_' + photoId).show();

    var err_div = '<div class="cropStatusErr">' + window.t('common.crop_error') + '</div>';
    $.ajax({
        type: "POST",
        url: "/app/albums",
        data: params,
        dataType: 'json'
    }).done(function (data, textStatus, jqXHR) {
        $('#cropStatus_' + photoId).hide();
        if (data.body) {
            $('#albPhotoBox_' + photoId).empty().html(data.body);
            // Update crop image data attributes for next crop session
            var cropImg = $('#ct_' + photoId);
            cropImg.data('tx', params.x).data('ty', params.y).data('ts', params.h);
            if (data.cover) {
                $('.headThumb').find('img').attr('src', data.thumb)
            }
            // Update Alpine.js album editor component with new thumbnail
            if (data.thumb600) {
                document.dispatchEvent(new CustomEvent('thumbnail-updated', {
                    detail: { photoId: String(photoId), thumbUrl: data.thumb600 }
                }));
            }
        } else {
            $('#cropStatus_' + photoId).show().empty().html(err_div);
        }
    }).fail(function (data, textStatus, jqXHR) {
        $('#cropStatus_' + photoId).show().empty().html(err_div);
    });
    return false;
}

// HTML5 Uploader
$(function () {
    var imgContainer = $('#img-container');
    var dropBox = $('#drop-box');
    var fileInput = $('#file-field');
    var form = $('#newupload');

    var ua = navigator.userAgent.toLowerCase();
    var is_win_safari = ua.indexOf("safari/") !== -1 && ua.indexOf("windows") !== -1 && ua.indexOf("chrome/") == -1;

    // check support of File API, FormData и FileReader

    if (!$.support.fileSelecting || is_win_safari) {
        // No html5 file sending support - show old form
        form.remove();
        if (!is_win_safari) $('.oldbrowser').show();
        return false;
    }

    form.show();
    $('#upload').hide();

    fileInput.damnUploader({
        // Where to send
        url: form.prop('action'),
        // fake file input name (will be set as 'key' in $_FILES)
        fieldName: 'newuploadfile',
        // File dropbox element or selector
        dropBox: dropBox,
        // Max files to upload
        limit: 40,
        // Whn max files count exceed - this will be run
        onLimitExceeded: function () {
            addFileuploadError('The number of maximum files per upload was reached');
        },
        // manual file add event handler, for multiple files will be called for each
        // if return true file will be added to queue automatically
        onSelect: function (file) {
            var supportedFormats = /image\/(jpeg|png|tiff|gif|jpg|heic|svg)/;
            if (!supportedFormats.test(file.type)) {
                addFileuploadError('File [' + file.name + '] is not a valid image format');
                return false;
            }

            if (form.data('maxfilesize') < file.size) {
                addFileuploadError('File [' + file.name + '] size is too large');
                return false;
            }

            addFileToQueue(file);
            return false;
        },
        // When all files uploaded
        onAllComplete: function () {
        }
    });

    window["updateProgress"] = function (bar, value) {
        var width = bar.width();
        var bgrValue = -width + (value * (width / 100));
        bar.attr('rel', value).css('background-position', bgrValue + 'px center').text(value + '%');
    }

    //  Show selected files, show thumbs and manual add to upload queue
    window["addFileToQueue"] = function (file) {
        // creating li - add name, thumb and progress bar
        var imgContainer = $('#img-container');
        var li = $('<li/>').appendTo(imgContainer);
        var title = $('<div style="word-wrap: break-word;"/>').text(file.name + ' ').appendTo(li);
        var cancelButton = $('<a/>').attr({
            href: '#cancel',
            'class': 'cancel',
            title: 'Cancel upload'
        }).text('X').appendTo(title);

        var pBar = '';

        // If browser supports native html5 fileupload
        if (!file.fake) {

            // Add image and progress bar
            var img = $('<img/>').appendTo(li);
            pBar = $('<div/>').addClass('progress').attr('rel', '0').text(window.t('common.uploading')).appendTo(li);

            // create FileReader and show img thumb
            if ($.support.fileReading) {
                var reader = new FileReader();
                reader.onload = (function (aImg) {
                    return function (e) {
                        aImg.attr('src', e.target.result);
                        aImg.attr('width', 176); // Max box size
                    };
                })(img);
                reader.readAsDataURL(file);
            }
        } else {
        }

        // Create upload object
        var uploadItem = {
            file: file,
            onProgress: function (percents) {
                if ($.support.uploadControl) updateProgress(pBar, percents);
            },
            onComplete: function (successfully, data, errorCode) {
                // Show upload errors
                var uerr = function (msg) {
                    title.empty().append($('<div/>')).addClass('uploadFail').html(msg + ' ');
                    $('<a/>').attr({
                        href: '#cancel',
                        'class': 'cancel',
                        title: 'Remove'
                    }).text('X').click(function () {
                        li.remove();
                        return false;
                    }).appendTo(title);
                };

                if (successfully) {
                    // try to decode response
                    var s = '';
                    try {
                        s = jQuery.parseJSON(data);
                    } catch (e) {}

                    if (typeof s.error != 'undefined') {
                        uerr(s.error);
                    } else if (typeof s.html != 'undefined') {
                        // remove box and add album item
                        li.remove();
                        // $('.albPhotoList').prepend(s.html);
                        window.location.reload();
                    } else {
                        uerr(window.t('common.server_error_retry'));
                    }
                } else {
                    if (!this.cancelled) {
                        switch (errorCode) {
                            case 0 :
                                uerr(window.t('common.connection_error'));
                                break;
                            case 404 :
                            case 500 :
                                uerr(window.t('common.server_error_retry'));
                                break;
                            default:
                                uerr(window.t('common.unknown_error'));
                                break;
                        }
                    }
                }
            }
        };

        var postData = { csrf_token: $('meta[name="csrf_token"]').attr('content') };
        if (uploadItem.addPostData) {
            uploadItem.addPostData(postData);
        }

        // Add to queue
        var queueId = fileInput.damnUploader('addItem', uploadItem);

        // 'Cancel' click handler
        cancelButton.click(function () {
            fileInput.damnUploader('cancel', queueId);
            li.remove();
            return false;
        });

        // Start upload automatically
        fileInput.startUploadItem(queueId);

        return uploadItem;
    }

    // dropBox init
    dropBox.bind({
        dragenter: function () {
            $('.dropbox-text').addClass('highlighted');
            return false;
        },
        dragover: function () {
            return false;
        },
        dragleave: function () {
            $('.dropbox-text').removeClass('highlighted');
            return false;
        },
        drop: function () {
            $('.dropbox-text').removeClass('highlighted');
            return false;
        }
    });

});
